import dataReducerGenerator from './dataReducerGenerator';
import { group, user } from './basicElements';

export const activities = dataReducerGenerator('activities');
export const groups = dataReducerGenerator('groups', group);
export const messages = assign => dataReducerGenerator('messages', {}, assign);
export const threads = assign => dataReducerGenerator('threads', {}, assign);
export const notifications = dataReducerGenerator('notifications');
export const onboardingOptions = dataReducerGenerator('onboardingOptions');
export posts from './posts';
export users from './users';



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/data/index.js